<mat-dialog-actions class="justify-content-between">
  <h3>
    {{ (readOnly ? 'LABEL.VIEW_LABEL' : 'LABEL.ADD_LABEL') | translate }}
    {{ 'LABEL.DISCHARGE' | translate }}
  </h3>
  <div class="d-flex justify-content-center">
    <a mat-icon-button color="primary" (click)="printDischargeDetails()" *ngIf="isUpdateMode && readOnly">
      <i-tabler name="printer" class="icon-25 d-flex text-primary"></i-tabler>
    </a>
    <button mat-icon-button (click)="close()">
      <i-tabler name="x" class="icon-25 d-flex"></i-tabler>
    </button>
  </div>
</mat-dialog-actions>
<mat-divider></mat-divider>
<mat-dialog-content [formGroup]="dischargeForm">
  <div *ngIf="isLoading" class="loader-wrapper">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  <div class="row" [class.sync-loading-content]="isLoading">
    <!-- Discharge Date -->
    <div class="col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'LABEL.DISCHARGE_DATE' | translate }}</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="dischargeDate" [min]="minDate" required
          [max]="maxDate" [readonly]="readOnly">
        <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="readOnly"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="dischargeForm.get('dischargeDate')?.hasError('required')">
          {{ 'REQUIRED.SELECT_DATE' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Discharge Time -->
    <div class="col-sm-6">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'LABEL.DISCHARGE_TIME' | translate }}</mat-label>
        <input matInput type="time" formControlName="dischargeTime" [readonly]="readOnly">
        <mat-error *ngIf="dischargeForm.get('dischargeTime')?.hasError('required')">
          {{ 'REQUIRED.SELECT_TIME' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Diagnosis (Read-only, from OPD Clinical) -->
    <div class="col-sm-12">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{ 'LABEL.DIAGNOSIS' | translate }}</mat-label>
        <textarea matInput formControlName="diagnosis" rows="3" readonly></textarea>
      </mat-form-field>
    </div>

    <!-- Final Diagnosis -->
    <div class="col-sm-12">
      <div class="d-flex align-items-center gap-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'LABEL.FINAL_DIAGNOSIS' | translate }}</mat-label>
          <textarea matInput formControlName="finalDiagnosis" rows="3" [readonly]="readOnly"></textarea>
          <a mat-icon-button matSuffix type="button" (click)="copyDiagnosisToFinal()"
            [matTooltip]="'BUTTON.COPY_FROM_DIAGNOSIS' | translate" *ngIf="!readOnly">
            <i-tabler name="copy" class="icon-18"></i-tabler>
          </a>
          <a mat-icon-button matSuffix type="button" (click)="openDiagnosisPopup()"
            [matTooltip]="'LABEL.SELECT_DIAGNOSIS' | translate" *ngIf="!readOnly">
            <i-tabler name="list-check" class="icon-18"></i-tabler>
          </a>
          <mat-error *ngIf="dischargeForm.get('finalDiagnosis')?.hasError('required')">
            {{ 'REQUIRED.NAME' | translate }}
          </mat-error>
        </mat-form-field>

      </div>
    </div>

    <!-- Treatment Advice -->
    <div class="col-sm-12">
      <div class="d-flex align-items-center gap-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'LABEL.TREATMENT_ADVICE' | translate }}</mat-label>
          <textarea matInput formControlName="treatmentAdvice" rows="4" [readonly]="readOnly"></textarea>
          <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openTemplatePopupforTreatmentAdvice()"
            [matTooltip]="'ENTITY.TEMPLATE' | translate" [disabled]="readOnly">
            <i-tabler name="template" class="icon-18"></i-tabler>
          </a>
        </mat-form-field>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="d-flex align-items-center gap-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ 'LABEL.DISCHARGE_CONDITION' | translate }}</mat-label>
          <textarea matInput formControlName="dischargeCondition" rows="4" [readonly]="readOnly"></textarea>
          <a mat-icon-button matSuffix class="tmpl-suffix" type="button" (click)="openTemplatePopup()"
            [matTooltip]="'ENTITY.TEMPLATE' | translate" [disabled]="readOnly">
            <i-tabler name="template" class="icon-18"></i-tabler>
          </a>
        </mat-form-field>
      </div>
    </div>

    <div class="col-sm-12 m-b-12">
      <app-prescription
        [patientData]="data?.patientDetails || patientDetails"
        [opdDeatils]="data?.opdDetails || opdDetails"
        [ipdData]="data?.ipdData || ipdData"
        [embedded]="true"
        [readOnly]="readOnly"
        (loadingChange)="onPrescriptionLoadingChange($event)">
      </app-prescription>
    </div>

    <div class="col-sm-12" *ngIf="followUpPatientId && followUpDoctorId && (!readOnly || followUpInitialValue)">
      <h4 class="f-s-16 f-w-600 m-t-8 m-b-12">{{ 'APPOINTMENT_RELATED.FOLLOW_UP_APPOINTMENT' | translate }}</h4>
      <app-follow-up-slot-picker
        [doctorId]="followUpDoctorId"
        [required]="false"
        [disabled]="readOnly"
        [initialValue]="followUpInitialValue"
        (valueChange)="onFollowUpValueChange($event)">
      </app-follow-up-slot-picker>
    </div>

  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
  <div class="d-flex align-items-center justify-content-end w-100 p-r-16">
    <button mat-stroked-button color="primary" *ngIf="canLinkAbha" class="m-r-8"
      [disabled]="isAbhaLinkDisabled" (click)="linkAdmissionToAbha()">
      <span class="d-flex align-items-center">
        <i-tabler name="id" class="icon-18 m-r-8 d-flex"></i-tabler>
        {{ abhaLinkLabel }}
      </span>
    </button>
    <button mat-stroked-button class="m-r-5" (click)="close()">
      {{ 'BUTTON.BTN_CLOSE' | translate }}
    </button>
    <button mat-flat-button color="primary" class="m-l-4" (click)="save()"
      [disabled]="dischargeForm.invalid || isPrescriptionLoading" *ngIf="!readOnly">
      {{ 'BUTTON.BTN_SAVE' | translate }}
    </button>
  </div>
</mat-dialog-actions>